import React from "react";

export function Logo() {
  return <img src={require("../media/logo.png")} alt="SEL Logo" />;
}